const WarningFooter = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 col-md-8">
                    <p className="text-muted">
                        WARNING: This site has not been tested on muggles and may produce unexpected side effects. Use with caution.
                     </p>
                </div>
            </div>
        </div>
    )
}

export default WarningFooter;